<template>
    <layout-main :banner="banner" subtitle="院内冷链管理系统">
        <template v-slot:content>
            <p class="text">院内的血液、药品、检验样本等医疗用品，其安全存储对环境温湿度有着十分严格的要求，温湿度过高或过低都有可能会对冷藏样本造成较大的影响。因此，对这些环境因素进行实时监测和管理显得尤为重要。</p>
            <img src="@/assets/coldChain/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 24小时实时监测冷藏设备温度变化，可形成温度变化报表</p>
            <p class="text weight">· 数据可直接对接院内系统</p>
            <p class="text weight">· 异常温度可及时发生告警信息</p>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/coldChain/banner.png'
export default {
    components: {
        layoutMain,
        
    },
    data () {
        return {
            banner: banner
        }
    }
}
</script>
<style lang="scss" scoped>
.weight{
    font-weight: 600;
    line-height: 3 !important;
}
.title{ 
    text-indent: 1.5em;
    font-size: 25px;
    text-align: left;
    margin: 20px 0 10px;
}
.text{
    line-height: 2;
}
.image1{
    width: 100%;
    margin: 50px 0;
}
</style>
